import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class CustomColumnService {
  coloumnData: any;
  constructor(private restangular: Restangular) { }

  public setColumnData(data) {
    this.coloumnData = data;
  }

  public getColumnData() {
    return this.coloumnData;
  }

  public updateDefaultColumn() {
    return this.restangular.all('updateDefaultColumn');
  }

  public restoreDefault() {
    return this.restangular.all('restoreDefaultColumn');
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/custom-column.service.ts